import { Box, Typography } from '@mui/material';

import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_WHITE,
  FORTA_YELLOW,
  FORTA_YELLOW_2,
} from '../../../../../utils/colors';
import { formatEntityId, history } from '../../../../../helpers';
import { ENTITY_PREFIX } from '../../../../../constants';
import { ClaimRejectedStatus } from '../constants';


interface ILinkedClaimProps {
  dataTestId?: string;
  index: number;
  claimId: number;
  isOriginalClaim?: boolean;
  isCurrentClaim?: boolean;
  secondaryStatus: string;
}

function LinkedClaimItems({
  dataTestId,
  index,
  isOriginalClaim,
  isCurrentClaim,
  claimId,
  secondaryStatus,
}: ILinkedClaimProps) {
  return (
    <Box>
      <Box sx={{ display: 'flex' }} mt={2} mr={10} data-testid={dataTestId}>
        <Box
          display={'inline'}
          sx={{
            borderRadius: '50%',
            backgroundColor: isCurrentClaim ? FORTA_BLUE.primary : FORTA_BLUE.light3,
            color: isCurrentClaim ? FORTA_WHITE : FORTA_BLUE.primary,
            fontWeight: 700,
            width: '24px',
            height: '24px',
          }}
        >
          {index}
        </Box>
        <Typography
          display="inline"
          ml={1.5}
          fontWeight={isCurrentClaim ? 700 : 400}
          color={isCurrentClaim ? FORTA_BLUE.primary : FORTA_BLACK}
        >
          {isCurrentClaim
            ? 'Currently viewing'
            : isOriginalClaim
              ? 'Original claim'
              : 'Corrected claim'}
        </Typography>
        <Typography
          ml={0.5}
          fontWeight={700}
          color={FORTA_BLUE.primary}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            history.navigate(`/billings/claims/${claimId}`);
          }}
        >
          {isCurrentClaim ? null : formatEntityId(claimId, ENTITY_PREFIX.Claim)}
        </Typography>
      </Box>
      {Object.values(ClaimRejectedStatus).some((status) => status === secondaryStatus) && (
        <Box sx={{ position: 'relative' }}>
          <Box
            sx={{
              borderLeft: `1px solid ${FORTA_BLUE.primary}`,
              borderBottom: `1px solid ${FORTA_BLUE.primary}`,
              width: '20px',
              height: '20px',
              position: 'absolute',
              borderBottomLeftRadius: '10px',
              top: -7,
              left: 10,
            }}
          ></Box>
          <Typography
            sx={{
              px: 1,
              fontSize: 12,
              ml: '30px',
              mt: '7px',
              borderRadius: '10px',
              width: 'fit-content',
              backgroundColor: FORTA_YELLOW_2,
              border: `1px solid ${FORTA_YELLOW}`,
            }}
          >
            Secondary Claim Rejection
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default LinkedClaimItems;
